module.exports = __webpack_public_path__ + "img/cr.27b4a30f.svg";